import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { SidePopupLayout } from "src/component"
import { moneyFormat } from "src/utils/utility"
import helpers from "src/utils/helpers"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

export const InvestmentDetails: React.FC<any> = ({data, handleLiquidate, handleAddFund, close}) => {
    const {API} = useContext(ApiContext)
    const [accruedInterest, setAccruedInterest] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const isActive = data?.accountStatus === 'Active'
    const {info: {institutionData}} = useContext(AppInfoContext)


    useEffect(() => {
        if (isActive) handleGetAccruedInterest()
    }, [])

    async function handleGetAccruedInterest() {
        setIsLoading(true)
        const response = await API.getAccruedInterest(data?.accountNumber)
        setIsLoading(false)
        if (response) setAccruedInterest(response.accruedInterest)
    }

    return (
        <SidePopupLayout close={close}>
            { (isLoading) &&
                <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                    <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                        <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                    </GridContainer>
                </AbsoluteContainer>
            }
            <ScreenTitle textSize="2.2" fontWeight="700">Investment Details</ScreenTitle>
            <CustomContainer topMargin="3">
                <CustomContainer
                    minHeight="19.6" borderColor="#EAECF0" padding="2" radius="0.8"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Principal Amount</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{moneyFormat(data?.amount,institutionData?.defaultCurrency)}</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Tenure</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data.tenureInDays} Days</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Start Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.interestAccrualCommencementDate ? helpers.splitDateTime(data?.interestAccrualCommencementDate)?.date : null}</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Maturity Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.maturationDate ? helpers.splitDateTime(data?.maturationDate)?.date : null}</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Interest Rate</AppSpan>
                            <AppText fontWeight="700" color="#0D968F">{data?.interestRate}%</AppText>
                        </GridContainer>
                        { isActive &&
                            <GridContainer width="auto" sizeUnit="" alignItems="end">
                                <AppSpan>Accrued Interest</AppSpan>
                                <AppText fontWeight="700" color="#0D968F">&#8358;{moneyFormat(accruedInterest, true,institutionData?.defaultCurrency)}</AppText>
                            </GridContainer>
                        }
                    </FlexRow>
                    {/* <GridContainer
                        bgColor="rgba(13, 150, 143, 0.07)"
                        radius="0.5" height="2.6" topMargin="1.5"
                    >
                        <FlexRow justifyContent="space-between" rightPadding="1">
                            <GridContainer 
                                height="2.6" bgColor="#0D968F" radius="0.5" 
                                width="auto" sizeUnit="" leftPadding="1" rightPadding="1"
                            >
                                <AppText textSize="0.9" fontWeight="500" color="#ffffff">&#8358;20,000</AppText>
                            </GridContainer>
                            <AppText textSize="0.9" fontWeight="600" color="#0D968F">&#8358;200,000</AppText>
                        </FlexRow>
                    </GridContainer> */}
                    { isActive &&
                        <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                            <GridContainer width="auto" sizeUnit="" alignItems="start">
                                <AppSpan>Expected Return</AppSpan>
                                <AppText fontWeight="700" color="#0D968F">&#8358;{moneyFormat(data?.expectedReturns, true,institutionData?.defaultCurrency)}</AppText>
                            </GridContainer>
                            <GridContainer width="auto" sizeUnit="" alignItems="end">
                                <AppSpan>Current Balance</AppSpan>
                                <AppText fontWeight="700" color="#0D968F">&#8358;{moneyFormat(data?.balance,institutionData?.defaultCurrency)}</AppText>
                            </GridContainer>
                        </FlexRow>
                    }
                </CustomContainer>
                { isActive &&
                    <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                        <Button 
                            width='13.9' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            onClick={handleLiquidate}
                        >
                            Liquidate Funds
                        </Button>
                        <Button 
                            width='10.4' height='4' 
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={handleAddFund}
                        >
                            Add Funds
                        </Button>
                    </FlexRow>
                }
            </CustomContainer>
        </SidePopupLayout>
    )
}